export const SEND_FOR_REGESTRATION_REQUEST = "SEND_FOR_REGESTRATION_REQUEST";
export const SEND_FOR_REGESTRATION_SUCCESS = "SEND_FOR_REGESTRATION_SUCCESS";
export const SEND_FOR_REGESTRATION_FAILURE = "SEND_FOR_REGESTRATION_FAILURE";

export const CLEAR_ERRORS = "CLEAR_ERRORS";